var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9924 0.288436C16.3853 -0.0961457 15.6147 -0.0961451 15.0076 0.288437C6.28962 5.81124 0.394246 15.453 0.00120822 26.5096C-0.0244103 27.2303 0.359065 27.9017 0.990426 28.2402C5.46785 30.6402 10.5766 32 16 32C21.4234 32 26.5322 30.6402 31.0096 28.2402C31.6409 27.9017 32.0244 27.2303 31.9988 26.5096C31.6058 15.453 25.7104 5.81124 16.9924 0.288436Z",
    fill: "#F650AA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.9924 0.288436C16.3853 -0.0961457 15.6147 -0.0961451 15.0076 0.288437C6.28962 5.81124 0.394246 15.453 0.00120822 26.5096C-0.0244103 27.2303 0.359065 27.9017 0.990426 28.2402C5.46785 30.6402 10.5766 32 16 32C21.4234 32 26.5322 30.6402 31.0096 28.2402C31.6409 27.9017 32.0244 27.2303 31.9988 26.5096C31.6058 15.453 25.7104 5.81124 16.9924 0.288436Z",
    fill: "url(#paint0_linear)",
    fillOpacity: 0.12,
    style: {
      mixBlendMode: "overlay"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 16,
    y1: 32,
    x2: 16,
    y2: -0.315286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222222"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.3b1752a55cb54c2182f9e1b420fd77d7.svg";
export { ForwardRef as ReactComponent };